export const channels = {
    values: {
        Ecommerce: 'Ecommerce',
        Tienda: 'Tienda',
        Wholesale: 'Wholesale',
        Marketplace: 'Marketplace',
        Franchises: 'Franchises'
    },
    labels: {
        Ecommerce: 'Ecommerce',
        Tienda: 'Tienda',
        Wholesale: 'Mayoristas',
        Marketplace: 'Marketplace',
        Franchises: 'Franquicias'
    }

};

export const subChannels = {
    values: {
        POS: 'POS',
        AppInStore: 'AppInStore',
        FacturaManual: 'FacturaManual',
        ControladorFiscal: 'ControladorFiscal',
        Vtex: 'Vtex',
        ML_Colecta: 'ML_Colecta',
        ML_Flex: 'ML_Flex',
        ML_Fullfilment: 'ML_Fullfilment',
        BNA: 'BNA',
        ERP: 'ERP'
    },
    labels: {
        POS: 'POS',
        AppInStore: 'Aplicacion',
        FacturaManual: 'Factura Manual',
        ControladorFiscal: 'Controlador Fiscal',
        Vtex: 'Vtex',
        ML_Colecta: 'Meli Colecta',
        ML_Flex: 'Meli Flex',
        ML_Fullfilment: 'Meli Fullfilment',
        BNA: 'BNA',
        ERP: 'ERP'
    }
};

export const channelsSelect = [
    {
        value: channels.values.Tienda,
        label: channels.labels.Tienda
    },
    {
        value: channels.values.Ecommerce,
        label: channels.labels.Ecommerce
    },
    {
        value: channels.values.Marketplace,
        label: channels.labels.Marketplace
    },
    {
        value: channels.values.Franchises,
        label: channels.labels.Franchises
    },
]

export const subChannelsSelect = [
    {
        value: subChannels.values.POS,
        label: subChannels.labels.POS,
        source: [channels.values.Tienda, channels.values.Franchises]
    },
    {
        value: subChannels.values.AppInStore,
        label: subChannels.labels.AppInStore,
        source: [channels.values.Tienda, channels.values.Franchises]
    },
    {
        value: subChannels.values.FacturaManual,
        label: subChannels.labels.FacturaManual,
        source: [channels.values.Tienda, channels.values.Franchises]
    },
    {
        value: subChannels.values.ControladorFiscal,
        label: subChannels.labels.ControladorFiscal,
        source: [channels.values.Tienda, channels.values.Franchises]
    },
    {
        value: subChannels.values.Vtex,
        label: subChannels.labels.Vtex,
        source: channels.values.Ecommerce
    },
    {
        value: subChannels.values.ML_Colecta,
        label: subChannels.labels.ML_Colecta,
        source: channels.values.Marketplace
    },
    {
        value: subChannels.values.ML_Flex,
        label: subChannels.labels.ML_Flex,
        source: channels.values.Marketplace
    },
    {
        value: subChannels.values.ML_Fullfilment,
        label: subChannels.labels.ML_Fullfilment,
        source: channels.values.Marketplace
    },
    {
        value: subChannels.values.BNA,
        label: subChannels.labels.BNA,
        source: channels.values.Marketplace
    },
    {
        value: subChannels.values.ERP,
        label: subChannels.labels.ERP,
        source: channels.values.Wholesale
    },
]